var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "52 28 96 144",
    viewBox: "52 28 96 144",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145 172H55c-1.658 0-3-1.342-3-3V46c0-1.658 1.342-3 3-3h24v6H58v117h84V49h-21v-6h24c1.658 0 3 1.342 3 3v123c0 1.658-1.342 3-3 3z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 130H70c-1.658 0-3-1.342-3-3V70c0-1.658 1.342-3 3-3h60c1.658 0 3 1.342 3 3v57c0 1.658-1.342 3-3 3zm-57-6h54V73H73v51z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 130H82c-1.658 0-3-1.342-3-3v-12c0-.618.19-1.222.548-1.729 1.688-2.394 11.713-7.178 20.452-7.178s18.765 4.784 20.452 7.178c.357.507.548 1.11.548 1.729v12c0 1.658-1.342 3-3 3zm-33-6h30v-7.556c-2.323-1.427-8.789-4.351-15-4.351s-12.677 2.924-15 4.351V124z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 103.094c-6.618 0-12-5.426-12-12.094v-2.906C88 81.426 93.382 76 100 76s12 5.426 12 12.094V91c0 6.668-5.382 12.094-12 12.094zM100 82c-3.308 0-6 2.733-6 6.094V91c0 3.36 2.692 6.094 6 6.094s6-2.733 6-6.094v-2.906c0-3.361-2.692-6.094-6-6.094z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M124 55v6H76v-6h48z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M70 55v6h-6v-6h6z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M136 55v6h-6v-6h6z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 61H88c-1.658 0-3-1.342-3-3V31c0-1.658 1.342-3 3-3h24c1.658 0 3 1.342 3 3v27c0 1.658-1.342 3-3 3zm-21-6h18V34H91v21z",
    fill: "#8F8C8C",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M121 139v6H79v-6h42z",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F8C8C",
    d: "M112 151v6H88v-6h24z",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBadge);
export default __webpack_public_path__ + "static/media/icon-badge.4894cd3cd8ea5674b31a49c354084ce9.svg";
export { ForwardRef as ReactComponent };